'use strict';

module.exports = /&#?(x)?([\w\d]{0,5});/gi;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/HTML_ENTITY_REG.js
// module id = 943
// module chunks = 0